import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function TrustedBySection() {
  return (
    <section className="bg-dark py-4">
      <Container>
        <div className="text-center mb-4">
          <p className="text-muted mb-0">
            Trusted by innovative companies worldwide
          </p>
        </div>
        <Row className="justify-content-center align-items-center gy-4">
          <Col xs={6} md={2} className="text-center">
            <svg width="100" height="30" viewBox="0 0 100 30">
              <text
                x="50"
                y="20"
                fontFamily="Arial"
                fontSize="16"
                fill="gray"
                textAnchor="middle"
              >
                COMPANY 1
              </text>
            </svg>
          </Col>
          <Col xs={6} md={2} className="text-center">
            <svg width="100" height="30" viewBox="0 0 100 30">
              <text
                x="50"
                y="20"
                fontFamily="Arial"
                fontSize="16"
                fill="gray"
                textAnchor="middle"
              >
                COMPANY 2
              </text>
            </svg>
          </Col>
          <Col xs={6} md={2} className="text-center">
            <svg width="100" height="30" viewBox="0 0 100 30">
              <text
                x="50"
                y="20"
                fontFamily="Arial"
                fontSize="16"
                fill="gray"
                textAnchor="middle"
              >
                COMPANY 3
              </text>
            </svg>
          </Col>
          <Col xs={6} md={2} className="text-center">
            <svg width="100" height="30" viewBox="0 0 100 30">
              <text
                x="50"
                y="20"
                fontFamily="Arial"
                fontSize="16"
                fill="gray"
                textAnchor="middle"
              >
                COMPANY 4
              </text>
            </svg>
          </Col>
          <Col xs={6} md={2} className="text-center">
            <svg width="100" height="30" viewBox="0 0 100 30">
              <text
                x="50"
                y="20"
                fontFamily="Arial"
                fontSize="16"
                fill="gray"
                textAnchor="middle"
              >
                COMPANY 5
              </text>
            </svg>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TrustedBySection;
